import servicesUtils from "../../../utils/servicesUtils";
import { get } from "lodash";
import { buildMultiSelectFilterRequest } from "../../SearchFilters/utils";

const getFilterPatientsCount = (
  apiParams = {},
  label,
  values,
  id,
  selectedWorkspace = null,
  isAlreadyFormatted = false,
  customFields = null
) => {
  const isLC = process.env.NEXT_PUBLIC_IS_LC === "true";

  return new Promise((resolve, reject) => {
    let endpoint;
    let params;

    if (isLC) {
      // For LC, use v2 endpoint with MultiSelectFilterRequest structure
      endpoint = "/patients/v2/";

      const { page_size, ...filterData } = apiParams;

      // If isAlreadyFormatted is true, data is already formatted (from profile counts call)
      // and we should skip buildMultiSelectFilterRequest which would call formatFiltersObj again
      // If false, data is raw saved filter and needs formatting via buildMultiSelectFilterRequest
      if (isAlreadyFormatted) {
        // Data is already formatted, construct payload directly without calling formatFiltersObj again
        params = {
          logic: "AND",
          filters: [filterData],
          unread_messages: false,
          page_size: page_size || 0,
          sort_by: "study",
          sort_order: "desc",
          only_counts: true,
        };
      } else {
        // Data is raw saved filter, needs to be formatted via buildMultiSelectFilterRequest
        const filtersArray = [{ values: filterData }];
        params = buildMultiSelectFilterRequest(filtersArray, {
          logic: "AND",
          page_size: page_size || 0,
          sort_by: "study",
          sort_order: "desc",
          pagination_id: null,
          page: "next",
          unread_messages: false,
          only_counts: true,
          search: "",
          selectedWorkspace: selectedWorkspace,
          customFields: customFields || null,
        });
      }
    } else {
      // For non-LC, use counts endpoint with existing structure
      endpoint = "/patients/counts/";
      params = apiParams;
    }

    servicesUtils
      .postService(endpoint, params)
      .then((data) => {
        const count = get(data, ["data", "count"], 0);
        resolve({ count, label, values, id });
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export default getFilterPatientsCount;
